import {ResearchLitElement, html, css} from '@core/research-lit-element';

class ResearchMap extends ResearchLitElement {
    static get is() {
        return 'research-map';
    }

    static get styles() {
        return css`
            .map {
                display: block;
                max-width: var(--content-max-width);
                width: 100%;
                height: 100%;
                margin: 0;
            }

            .gm-style-iw {
                opacity: 0;
                width: 405px;
                margin: 0 !important;
                padding: 0 !important;
            }

            .gm-style-iw-c {
                margin: 0 !important;
                padding: 0 !important;
                border-radius: var(--space-12) !important;
            }

            .gm-style-iw-d {
                margin: 0 !important;
                padding: 0 !important;
                overflow: unset !important;
            }

            .gm-style-iw[active] {
                opacity: 1;
                width: 450px;
                transition: opacity 0.3s ease-in-out;
            }

            .gmnoprint button > img:not(:first-of-type),
            .gm-fullscreen-control > img:not(:first-of-type) {
                display: none;
            }

            .gm-style-iw button.gm-ui-hover-effect {
                top: var(--space-8) !important;
                right: var(--space-8) !important;
            }

            .gm-style-iw .gm-ui-hover-effect {
                visibility: hidden;
            }

            @media (max-width: 1024px) {
                .gm-style-iw[active] {
                    max-width: 350px !important;
                    width: 350px;
                }
            }

            @media (max-width: 768px) {
                .gm-style-iw[active] {
                    max-width: 250px !important;
                    width: 250px;
                }
            }

            @media (max-width: 600px) {
                :host {
                    --height: 385px;
                }

                .map {
                    height: var(--height);
                }
            }
        `;
    }

    render() {
        return html` <div id="map" class="map"></div> `;
    }

    static get properties() {
        return {
            data: {
                type: Object,
            },
            map: {
                type: Object,
            },
            infoWindows: {
                type: Array,
            },
            markerCluster: {
                type: Object,
            },
            searchResult: {
                type: Array,
            },
            selectedCoords: {
                type: Object,
            },
        };
    }

    updated(changedProperties) {
        if (changedProperties.has('searchResult')) {
            this._searchResultChanged();
        }
        if (changedProperties.has('selectedCoords')) {
            this._selectedCoordsChanged();
        }
    }

    firstUpdated() {
        setTimeout(() => {
            const mapDiv = this.shadowRoot.getElementById('map');
            this.map = new google.maps.Map(mapDiv, {
                zoom: 12,
                center: {lat: 41.746816, lng: 44.797197},
                clickableIcons: false,
                mapTypeControl: false,
                streetViewControl: false,
            });

            google.maps.event.addListener(this.map, 'click', this._removeAllInfowindows.bind(this));
            this.infoWindows = [];
            this.markerCluster = new MarkerClusterer(this.map, null, {
                styles: [
                    {
                        url: this.data?.pinGroupIcon?.url ?? '',
                        height: 44,
                        width: 44,
                    },
                ],
            });
            this._searchResultChanged();
            // this._selectedCoordsChanged();
        }, 1500);
    }

    _searchResultChanged() {
        if (!this.markerCluster) return;

        this.markerCluster.clearMarkers();
        const markers = [];

        for (let i = 0; i < this.searchResult.length; i++) {
            const location = this.searchResult[i];
            const pinIconUrl = this.data.pinIcon.url;

            const iconData = {
                url: pinIconUrl,
                scaledSize: new google.maps.Size(64, 64),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(32, 64),
            };

            const marker = new google.maps.Marker({
                position: new google.maps.LatLng(location.latitude, location.longitude),
                icon: iconData,
            });

            markers.push(marker);
        }
        this.markerCluster.addMarkers(markers);
        this._fitMarkerBounds(markers);
    }

    _fitMarkerBounds(markers) {
        if (markers.length === 0) return;
        const bounds = new google.maps.LatLngBounds();
        for (let i = 0; i < markers.length; i++) {
            bounds.extend(markers[i].getPosition());
        }
        this.map.fitBounds(bounds);
    }

    _removeAllInfowindows() {
        for (let i = 0; i < this.infoWindows.length; i++) {
            this.infoWindows[i].close();
        }
    }

    _selectedCoordsChanged() {
        const {latitude, longitude} = this.selectedCoords;
        this.map.setCenter(new google.maps.LatLng(latitude, longitude));
        this.map.setZoom(18);
    }
}

window.customElements.define(ResearchMap.is, ResearchMap);
